import React, { useState, useEffect } from 'react';

function Profile() {

    // if (loadingS || loadingD || loadingL || loadingDo) {
    //     return <div className="flex flex-1 justify-center items-center"><Loader /></div>;
    // }

    // console.log("lstRdv:",lstRdv);
    // console.log(locations);

    return (
        <div class="flex-1 p-10">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12 mt-8">
                        <h1 class="mb-10 w-full font-bold text-gray-800 text-4xl text-center">Profile</h1>
                    </div>
                </div>
            </div>
            <div class="flex justify-center p-4 px-3 py-10">
                <div class="w-full max-w-md">
                    <div class="bg-white shadow-md mb-4 px-3 py-2 rounded-lg">
                        <div class="block px-2 py-2 font-semibold text-gray-700 text-lg">
                            Item List
                        </div>
                        <div class="flex items-center bg-gray-200 rounded-md">
                            <div class="pl-2">
                                <svg class="fill-current w-6 h-6 text-gray-500" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24">
                                    <path class="heroicon-ui"
                                        d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
                                </svg>
                            </div>
                            <input
                                class="bg-gray-200 px-2 py-2 rounded-md focus:outline-none w-full text-gray-700 leading-tight"
                                id="search" type="text" placeholder="Search teams or members"/>
                        </div>
                        <div class="py-3 text-sm">
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-gray-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Tighten Co.</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Team</div>
                            </div>
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-green-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Taylor Otwell</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Member</div>
                            </div>
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-gray-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Adam Wathan</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Member</div>
                            </div>
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-gray-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Duke Street Studio Inc.</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Team</div>
                            </div>
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-green-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Jeffrey Wey</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Member</div>
                            </div>
                        </div>
                        <div class="block bg-gray-200 -mx-3 -mb-2 px-3 py-2 rounded-b-lg text-sm text-right">
                            <button class="px-4 py-2 font-bold text-gray-500 hover:text-gray-600">
                                Cancel
                            </button>
                            <button class="bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded font-bold text-white">
                                Invite
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Profile;
